import { EntityDto, EntityWithUserDto } from "../entity/entity.dto";
import {
    WorkspaceMemberEntityAssignment,
    WorkspaceMemberEntityAssignmentBase,
} from "../../types/workspace";

export class WorkspaceMemberEntityAssignmentDto {
    static deserialize(
        dto: WorkspaceMemberEntityAssignmentDto,
    ): WorkspaceMemberEntityAssignment {
        return {
            entity: EntityDto.deserialize(
                dto.entity,
            ) as WorkspaceMemberEntityAssignment["entity"],
        };
    }

    entity: EntityDto;

    constructor(
        workspaceEntityAssignment: WorkspaceMemberEntityAssignmentBase,
    ) {
        this.entity = new EntityWithUserDto(workspaceEntityAssignment.entity);
    }
}
